import { getStoredAuthState } from '@plexxis/react-auth-provider';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const importsUrl: string = import.meta.env.VITE_API_URL || '__Xx__VITE_API_URL__xX__';

export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${window.location.protocol}//${importsUrl}`,
    timeout: 600000,
    prepareHeaders: (headers) => {
      const authState = getStoredAuthState();
      if (authState.status == 'loggedIn') {
        headers.set('Authorization', `Bearer ${authState.loginDetails.accessToken}`);
      }

      return headers;
    },
  }),

  reducerPath: 'importsApiReducer',
  endpoints: () => ({}), // Define your endpoints here.
});
